// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"SalesTools_paginationPageDropdownWrap__Z5Dmd","linkWidgetDescription":"SalesTools_linkWidgetDescription__gc301"};